import React, { useState } from "react";
import { X, Minus, Plus } from "lucide-react";
import { useProducts } from "../context/ProductsContext";

interface EditQuantityModalProps {
  productId: string;
  onClose: () => void;
}

const EditQuantityModal: React.FC<EditQuantityModalProps> = ({
  productId,
  onClose,
}) => {
  const { products, updateProductQuantity } = useProducts();
  const product = products.find((p) => p.id === productId);

  const [quantity, setQuantity] = useState(product?.quantity || 1);

  if (!product) return null;

  const handleSave = () => {
    updateProductQuantity(product.id, quantity);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[1100]">
      <div className="bg-white rounded-xl w-[380px] p-6 shadow-lg relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="text-xl font-semibold text-[#402B69] mb-4 text-center">
          Edit Quantity
        </h2>

        <p className="text-center text-gray-600 mb-2">{product.name}</p>

        <div className="flex justify-center items-center gap-4 mt-6 mb-6">
          <button
            onClick={() => setQuantity((q) => Math.max(1, q - 1))}
            className="w-10 h-10 flex items-center justify-center rounded-full border text-[#885ABB] hover:bg-[#f4e9ff]"
          >
            <Minus />
          </button>

          <span className="text-2xl font-bold text-[#402B69]">{quantity}</span>

          <button
            onClick={() => setQuantity((q) => q + 1)}
            className="w-10 h-10 flex items-center justify-center rounded-full border text-[#885ABB] hover:bg-[#f4e9ff]"
          >
            <Plus />
          </button>
        </div>

        <button
          onClick={handleSave}
          className="w-full bg-[#885ABB] hover:bg-[#6f3fa8] text-white font-semibold rounded-md py-3 transition"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default EditQuantityModal;
